module.exports = __webpack_public_path__ + "img/Indonesia-06.08f95dd0.jpg";